import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=4683afeb&scoped=true"
import script from "./file-uploader.ts?vue&type=script&lang=ts&external"
export * from "./file-uploader.ts?vue&type=script&lang=ts&external"
import style0 from "./file-uploader.less?vue&type=style&index=0&id=4683afeb&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683afeb",
  null
  
)

export default component.exports